import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AddStopsHelpPage } from './add-stops-help.page';

const routes: Routes = [
  {
    path: '',
    component: AddStopsHelpPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AddStopsHelpPageRoutingModule {}
